export default {
  default_program_name: 'Rewards Club',
  message:
    'Tritt <highlight>{{name}}</highlight> bei — sammle {{reward}} für jede {{spend}}, die du ausgibst, und sichere dir Gratis-Artikel!',
  buttons: {
    join_now: 'Jetzt beitreten',
  },
};
